<template>
  <div oncontextmenu="return false" :data="pdfLocation" :sources="pdfLocation" :location="pdfLocation" class="viewer" :source="this.$route.params.source | formatUrlPdf">
    <div class="container-fluid viewer pt-0">
      <div class="div"> 
        <div class="row w-100 mx-auto">
          <div class="col-12" style="padding-bottom:30px; height:100vh;">
          <button type="button" class="close closeMagazine" @click="closeMagazine" aria-label="Close">
              <span class="closeMagazine" aria-hidden="true">&times;</span>
          </button>
            <!--FLipbook-->
            <div class="_df_book" 
            id="magazineViewer"
            >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewerMagazine",
  props: ["active"],
  components: {
  },
  data(){
    return{
      stateViewer: false,
      pdfLocation: ""
    }
  },
  mounted(){
    // verifica la ruta de el pdf si existe en el flujo normal ,
    // si no retorna a e el perfil
    if(this.$route.params.source === undefined){
      this.closeMagazine();
    }else{
      console.log('pdf: ', this.$route.params.source);
        this.setupViewer();
    }
    // creacion de atributos para dificultar descarga de pdf
    this.pdfLocation = this.$route.params.source + btoa(this.$route.params.source);
    this.pdfLocation = this.pdfLocation.replace("https://mmkgroup-staging-domains-mmkgroupstagingdevadminm", "security-domain")
    for (let i = 0; i < 21; i++) {
      document.querySelector(".viewer").setAttribute("source"+i, this.pdfLocation);
    }
  },
  methods: {
    closeMagazine: function(){
        console.log('retorna');
        this.$router.push({
            name: 'magazine',
            params: { active: true },
        });
    },
    setupViewer: function(){
        var pdf = this.$route.params.source;
        var options = {
          height: '100%', 
          webgl : false, 
          webglShadow : false,
          scrollWheel : false,
          backgroundcolor : 'ghostwhite',
          overwritePDFOutline: false,
          hideControls: "download, pageMode, outline",
          enableAnnotation: false,
          enableDownload: false,
          pageMode: DFLIP.PAGE_MODE.AUTO,
          pixelRatio: window.devicePixelRatio || 1,
          pageSize: DFLIP.PAGE_SIZE.AUTO
          };
        var flipBook = $("#magazineViewer").flipBook(pdf, options);
      }
  },
  filters: {
    formatUrlPdf: function(value){
      value = value + Math.random();
    }
  }
};
</script>
<style lang="scss">
.div{
    position: relative;
    width: 100%;
}
.viewer {
    width: 100vw;
    height: 100vh;
    position: absolute;
    background-color: ghostwhite;
    margin: 0;
    padding: 1% 0;
    top: 0;
    z-index: 10000000000;
    overflow: hidden;
}
.close{
    position: absolute;
    top: 1%;
    right: 2%;
    font-size: 1.8vw;
    z-index:100;
}
.close.closeMagazine {
    opacity: 1;
}
.df-floating .df-ui-controls {
    bottom: 15px;
    box-shadow: 0px 0px 10px gray;
}
span.closeMagazine{
  color:#ea1a46;
}
[class^="ti-"]:before, [class*=" ti-"]:before {
    font-weight: normal;
    color:#ea1a46;
}
.df-ui-page label {
    color: black !important;
}
.df-ui-wrapper, .df-ui-btn {
    color: black !important;
    font-weight: 500;
}
.df-container .loading-info {
    margin-top: 40px;
    background-color: #fdfdfd4d;
    border-radius: 0px;
    font-size: 12px;
    font-weight: 900;
    color: #0a1527;
    left: 50%;
}
.df-container.df-loading:after {
    background-size: 100%;
    background-position: center;
}
.df-container:before, .df-container:after {
    height: 100px;
    width: 150px;
    left: 50%;
    top: 50%;
    margin: auto;
    transform: translate(-50%, -78%);
}
div[source]{
  color:transparent;
}
</style>
